import React from "react";
import { motion } from "framer-motion";

/**
 * Small animated equalizer badge shown when a release is the currently playing track.
 * Uses eq-bar keyframes from index.css.
 */
const NowPlayingBadge = ({ label = "Now Playing", className = "" }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    className={`inline-flex items-center gap-2 rounded-full bg-[#FF9933] text-black px-2.5 py-1 text-[9px] uppercase tracking-[0.25em] font-semibold ${className}`}
    data-testid="now-playing-badge"
  >
    <span className="flex items-end gap-[2px] h-3">
      {[0.1, 0.3, 0.2, 0.4].map((d, i) => (
        <span key={i} className="w-[2px] bg-black eq-bar rounded-sm" style={{ height: "100%", animationDelay: `${d}s` }} />
      ))}
    </span>
    {label}
  </motion.div>
);

export default NowPlayingBadge;
